<template>
    <DatePicker
      v-model="selectedDateTime"
      :disabled="disabled"
      :disabled-date="notBeforeToday"
      :minute-step="15"
      :class="customClass"
      type="datetime"
      format="YYYY-MM-DD HH:mm"
      :default-value="new Date()"
      :placeholder="$t('app.inspections.attributes.date_of_maturity')"
      :popup-class="'date-picker-popup'"
      @change="$emit('update', selectedDateTime)"
    />
  </template>
  
  <script>
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
  import 'vue2-datepicker/locale/hu';

  
  export default {
    name: "DateTimePicker",
    components: { DatePicker },
    props: {
      value: Date, // v-model compatibility
      disabled: {
        type: Boolean,
        default: false,
      },
      customClass: {
        type: String,
        default: "",
      },
    },
    data() {
        return {
        }
    },
    computed: {
      selectedDateTime: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        },
      },
    },
    methods: {
        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },
    },
  };
  </script>
  
  <style scoped>
  .date-picker-popup {
    background-color: aqua;
  }
  /* Add custom styling here if needed */
  </style>
  


// WEBPACK FOOTER //
// src/components/shared/inputs/DateTimePicker.vue